/*eslint-disable*/

import {
  AppBar,
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Dialog,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  InputAdornment,
  List,
  Paper,
  Radio,
  RadioGroup,
  TextField,
  Toolbar,
  Typography,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';

import { toast } from 'react-toastify';
import { Close } from '@mui/icons-material';
import moment from 'moment';

import palette from '../../theme/palette';
import { useResponsiveStyles } from '../../utils/responsiveStyles';
import Key from '../../clientVariables.json';
import Purchaseorderview from '../Purchaseorderview';

const PaymentForm = ({ addCustomerResponse }) => {
  const currentUser = useSelector((state) => state.UserReducer.user);
  const [customerDetails, setCustomerDetails] = useState(null);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [buttonStatus, setButtonStatus] = useState(false);
  const [adjustedStartDate, setAdjustedStartDate] = useState('');
  const history = useNavigate();
  const location = useLocation();

  const isOpenPlanUpgrade = useSelector((state) => state.upgradePlan.isOpen);
  const editPlanData = useSelector((state) => state.upgradePlan.planData);

  const [formData, setFormData] = useState({
    plan: 'Basic',
    planTerm: 'monthly',
    users: 3,
    views: 1200,
    discount: '',
    extraViews: '',
    isTrail: false,
    trialDuration: ""
  });
  const [formErrors, setFormErrors] = useState({});
  const styles = useResponsiveStyles();
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    getCustomerDetails();

  }, [isOpenPlanUpgrade]);

  // useEffect(() => {
  //   if (isOpenPlanUpgrade) {
  //     setFormData((prev) => ({
  //       ...prev,
  //       plan: customerDetails?.packageDetails?.plan === 'basic' ? 'Basic' : 'Custom',
  //       planTerm: customerDetails?.packageDetails?.plan_term,
  //       users: customerDetails?.packageDetails?.users_allowed,
  //       views: customerDetails?.packageDetails?.resumeviews_allowed,
  //       discount: customerDetails?.packageDetails?.discount_perc,
  //       isTrail: customerDetails?.packageDetails?.trail_period === 1
  //     }));
  //   }
  // }, [customerDetails])

  //   useEffect(() => {
  //     if (formData.planTerm === 'monthly') {
  //       setFormData((prev) => ({
  //         ...prev,
  //         views: formData.users * 400,
  //       }));
  //     }
  //     if (formData.planTerm === 'yearly') {
  //       setFormData((prev) => ({
  //         ...prev,
  //         views: formData.users * 8000,
  //       }));
  //     }
  //     if (formData.planTerm === 'halfYearly') {
  //       setFormData((prev) => ({
  //         ...prev,
  //         views: formData.users * 4000,
  //       }));
  //     }
  //     if (formData.planTerm === 'quarterly') {
  //       setFormData((prev) => ({
  //         ...prev,
  //         views: formData.users * 2000,
  //       }));
  //     }
  //   }, [formData.users, formData.planTerm]);

  useEffect(() => {
    if (formData.planTerm === 'monthly') {
      setFormData((prev) => ({
        ...prev,
        views: 1200,
      }));
    }
    if (formData.planTerm === 'yearly') {
      setFormData((prev) => ({
        ...prev,
        views: 24000,
      }));
    }
    if (formData.planTerm === 'halfYearly') {
      setFormData((prev) => ({
        ...prev,
        views: 12000,
      }));
    }
    if (formData.planTerm === 'quarterly') {
      setFormData((prev) => ({
        ...prev,
        views: 6000,
      }));
    }
  }, [formData.planTerm]);

  useEffect(() => {
    console.log(formData);
  }, [formData])

  const handleChange = (field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
      trialDuration: field === 'isTrail' && !value ? "" : 3,
      // trialDuration: field === 'isTrail' && !value ? "" : prevData.trialDuration,
      ...(field === 'plan' && { planTerm: value === 'Custom' ? 'yearly' : 'monthly' }),
    }));
  };
  //   const handleChange = (field, value) => {
  //     setFormData((prevData) => ({
  //       ...prevData,
  //       [field]: value,
  //     }));
  //   };
  const handleDropdownChange = (event) => {
    let duration = event.target.value
    setFormData((prevData) => ({
      ...prevData,
      trialDuration: duration,
    }));

  };
  const handleNumberChange = (field, value) => {
    // const value = e.target.value;
    const numberValue = Number(value);
    if (field === 'discount') {
      if (!Number.isNaN(numberValue)) {
        handleChange(field, value);
      }
    }
    if (!Number.isNaN(numberValue) && (numberValue >= 3 || value === '')) {
      handleChange(field, value);
    }
  };

  function getFutureDate(days, trailDays) {
    let totalDays = parseInt(days) + parseInt(trailDays || 0);
    let today_date = new Date().toISOString();
    var end_date = moment(today_date).add(totalDays, 'd');
    let date = end_date.toISOString();

    return date;
  }

  const submitHandler = async (e) => {
    e.preventDefault();

    const errors = validateForm();
    setFormErrors(errors);

    if (Object.keys(errors).length === 0 && (addCustomerResponse || editPlanData)) {
      console.log('formData', formData);
      const userId = isOpenPlanUpgrade ? editPlanData?.userDetails?.id : addCustomerResponse?.user_id;
      const comId = isOpenPlanUpgrade ? editPlanData?.userDetails?.company_id : addCustomerResponse?.company_id;
      try {
        const planDays = planDaysHandler(formData.planTerm);
        const price = calculateTotalAmount(formData.users, formData.planTerm, formData.discount);
        const response = await axios.post(`${Key.domain}/customer/subscription/add`, {
          user_id: userId,
          admin_id: currentUser?.id,
          invoice_no: '',
          company_id: comId,
          //   package_id: '0',
          jobs_allowed: 100000,
          resumeviews_allowed: formData.views,
          users_allowed: formData.users,
          jobs_addon: 0,
          resumeviews_addon: '',
          users_addon: '',
          //   companies_allowed: 0,
          //   status: 1,
          //   action: '0',
          //   session_token: currentUser?.session_token,
          //   package_expires_in_days: planDays,
          subscription_days: planDays,
          plan: formData.plan,
          plan_term: formData.planTerm,
          enrolled_date: new Date().toISOString(),
          package_start_date: formData.isTrail ? getFutureDate(formData.trialDuration) : getFutureDate(0),
          package_end_date: formData.isTrail ? getFutureDate(planDays, formData.trialDuration) : getFutureDate(planDays, 0),
          price: price,
          discount_perc: formData.discount,
          resume_views_extra: formData.extraViews,
          trail_period: !formData.isTrail ? 0 : 1
        });
        if (response.status === 200) {
          getCustomerDetails();
          setOpen(true);
          toast.success('Successfully inserted Customer Subscription', {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        } else {
          toast.error('Customer Subscription insertion Failed', {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        }
      } catch (error) {
        console.error(error);
        toast.error('Customer Subscription insertion Failed', {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
    } else {
      const firstErrorField = Object.keys(errors)[0];
      document.getElementById(firstErrorField)?.focus();
      toast.error('Something went wrong', {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.plan?.trim()) {
      errors.plan = 'Select Plan';
    } else if (!formData.planTerm?.trim()) {
      errors.planTerm = 'Plan Term is required';
    } else if (!formData.users) {
      errors.users = 'Users is required';
    } else if (!formData.views) {
      errors.views = 'Views is required';
    }

    return errors;
  };

  const getCustomerDetails = async () => {
    const userId = isOpenPlanUpgrade ? editPlanData?.userDetails?.id : addCustomerResponse?.user_id;
    try {
      const response = await axios.post(`${Key.domain}/customer/get_upgrade_packagedetails`, {
        customer_id: userId,
      });
      if (response.status === 200) {
        console.log(response.data.data);
        setCustomerDetails(response.data.data);
      }
    } catch (error) {
      console.error(error);
      toast.error('Failed to fetch package details', {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  const handleSendMail = async () => {
    setButtonLoading(true);
    const userId = isOpenPlanUpgrade ? editPlanData?.userDetails?.id : customerDetails?.userDetails?.id;
    const comId = isOpenPlanUpgrade ? editPlanData?.userDetails?.company_id : addCustomerResponse?.company_id;
    const email = isOpenPlanUpgrade ? editPlanData?.userDetails?.username : customerDetails.userDetails.username;
    const price = isOpenPlanUpgrade ? editPlanData?.packageDetails?.price : customerDetails.packageDetails.price;
    try {
      const response = await axios.post(`${Key.domain}/payment/send_payment_mail`, {
        crm_userid: currentUser?.id,
        session_token: currentUser.session_token,
        customer_id: userId,
        customer_email: email,
        agreementData: customerDetails,
        price: price,
      });
      if (response.status === 200) {
        trackStatusUpdateForAdmin(3);
        let msg = 'Mail sent to customer successfully!';
        toast.success(msg, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        history('/dashboard/user');
        setButtonLoading(false);
      }
    } catch (error) {
      console.error(error);
      let msg = 'Sending mail failed try again!';
      toast.error(msg, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      setButtonLoading(false);
    }
  };

  const calculateTotalAmount = (users, planTerm, discount) => {
    let amountPerUser;
    switch (planTerm) {
      case 'yearly':
        amountPerUser = 1200;
        break;
      case 'monthly':
        amountPerUser = 100;
        break;
      case 'halfYearly':
        amountPerUser = 600;
        break;
      case 'quarterly':
        amountPerUser = 300;
        break;
      default:
        amountPerUser = 0;
    }

    const totalAmount = users * amountPerUser;
    const discountAmount = (totalAmount * (discount || 0)) / 100;
    return totalAmount - discountAmount;
  };

  const trackStatusUpdateForAdmin = async (flowStatus) => {
    try {
      const response = await axios.post(`${Key.domain}/customer/insert_or_update_subscriptions_trackStatus`, {
        customer_id: props.companyuserid,
        customer_name: customerDetails.userDetails.full_name,
        customer_email: customerDetails.userDetails.username,
        current_package_id: customerDetails.packageDetails.package_id,
        targeted_package_id: packageId,
        status: 1,
        flow_status: flowStatus === 3 ? flowStatus : 2,
        action_status: 0,
      });
      if (response.data.success === 1) {
        setButtonStatus(false);
      }
    } catch (error) {
      setButtonStatus(false);

      console.log(error);
    }
  };

  const sendUpgradtionMailForFreePackageCustomers = () => {
    axios
      .post(`${Key.domain}/payment/send_upgradation_mail`, {
        user_id: sessionStorage.getItem('id'),
        customer_id: props.companyuserid,
        to_email_id: customerDetails.userDetails.username,
        customer_name: customerDetails.userDetails.full_name,
      })
      .then((response) => {
        console.log(response);

        if (response.data.success === 1) {
          alert(response.data.data);
          setButtonStatus(false);
          history('/dashboard/user');
        }
      });
  };

  //   const sendPaymentLink = () => {
  //     setButtonStatus(true);
  //     if (viewsPackage === '') {
  //       alert('Views Allowed is mandatory');
  //     } else {
  //       setJobsAllowed(
  //         parseInt(postPackage) < 0 ||
  //           postPackage === null ||
  //           !postPackage ||
  //           postPackage === 'null' ||
  //           postPackage === '' ||
  //           postPackage === undefined
  //           ? 0
  //           : parseInt(postPackage) + parseInt(extraPosts)
  //       );
  //       setResumesAllowed(
  //         parseInt(viewsPackage) < 0 ||
  //           viewsPackage === null ||
  //           !viewsPackage ||
  //           viewsPackage === 'null' ||
  //           viewsPackage === '' ||
  //           viewsPackage === undefined
  //           ? 0
  //           : parseInt(viewsPackage) + parseInt(extraViews)
  //       );
  //       setCompaniesAllowed(
  //         parseInt(companiesPackage) < 0 ||
  //           parseInt(companiesPackage) === 0 ||
  //           companiesPackage === null ||
  //           !companiesPackage ||
  //           companiesPackage === 'null' ||
  //           companiesPackage === '' ||
  //           companiesPackage === undefined
  //           ? 0
  //           : parseInt(companiesPackage) + parseInt(extraCompanies)
  //       );
  //       setRecruitersAllowed(
  //         parseInt(recruitersPackage) < 0 ||
  //           recruitersPackage === null ||
  //           !recruitersPackage ||
  //           recruitersPackage === '' ||
  //           recruitersPackage === 'null' ||
  //           recruitersPackage === undefined
  //           ? 0
  //           : parseInt(recruitersPackage) + parseInt(extraRecuiters)
  //       );

  //       if (
  //         (parseInt(postPackage) < 0 ||
  //           parseInt(postPackage) === 0 ||
  //           postPackage === null ||
  //           !postPackage ||
  //           postPackage === 'null' ||
  //           postPackage === '' ||
  //           postPackage === undefined) &&
  //         (parseInt(viewsPackage) < 0 ||
  //           parseInt(viewsPackage) === 0 ||
  //           viewsPackage === null ||
  //           !viewsPackage ||
  //           viewsPackage === 'null' ||
  //           viewsPackage === '' ||
  //           viewsPackage === undefined) &&
  //         (parseInt(companiesPackage) < 0 ||
  //           parseInt(companiesPackage) === 0 ||
  //           companiesPackage === null ||
  //           !companiesPackage ||
  //           companiesPackage === 'null' ||
  //           companiesPackage === '' ||
  //           companiesPackage === undefined) &&
  //         (parseInt(recruitersPackage) < 0 ||
  //           parseInt(recruitersPackage) === 0 ||
  //           recruitersPackage === null ||
  //           !recruitersPackage ||
  //           recruitersPackage === '' ||
  //           recruitersPackage === 'null' ||
  //           recruitersPackage === undefined)
  //       ) {
  //         let msg = 'Package details must be atleast 1';
  //         toast(<ToastMessage message={msg} />);
  //         setButtonStatus(false);
  //       } else {
  //         axios
  //           .post(`${Key.domain}/customer/insert_or_update_customer_subscription`, {
  //             userid: props.companyuserid !== undefined ? props.companyuserid : location.state.customerid,
  //             admin_id: sessionStorage.getItem('id'),
  //             //"empidsub": 1,
  //             company_id: packageDetails !== undefined ? compid : props.companyId,
  //             package_id: packageId,
  //             jobs_allowed: 100000,
  //             // parseInt(postPackage) < 0 ||
  //             // postPackage === null ||
  //             // !postPackage ||
  //             // postPackage === 'null' ||
  //             // postPackage === '' ||
  //             // postPackage === undefined
  //             //   ? 0
  //             //   : parseInt(postPackage) + parseInt(extraPosts),
  //             resumeviews_allowed:
  //               parseInt(viewsPackage) < 0 ||
  //               viewsPackage === null ||
  //               !viewsPackage ||
  //               viewsPackage === 'null' ||
  //               viewsPackage === '' ||
  //               viewsPackage === undefined
  //                 ? 0
  //                 : parseInt(viewsPackage) + parseInt(extraViews),
  //             users_allowed:
  //               parseInt(recruitersPackage) < 0 ||
  //               recruitersPackage === null ||
  //               !recruitersPackage ||
  //               recruitersPackage === '' ||
  //               recruitersPackage === 'null' ||
  //               recruitersPackage === undefined
  //                 ? 0
  //                 : parseInt(recruitersPackage) + parseInt(extraRecuiters),

  //             jobs_addon: parseInt(values.extraPosts) + parseInt(values.addposts ? values.addposts : 0),
  //             resumeviews_addon: parseInt(values.extraViews) + parseInt(values.addviews ? values.addviews : 0),
  //             users_addon: parseInt(values.extraRecruiters) + parseInt(values.addrecruiters ? values.addrecruiters : 0),

  //             companies_allowed:
  //               parseInt(companiesPackage) < 0 ||
  //               parseInt(companiesPackage) === 0 ||
  //               companiesPackage === null ||
  //               !companiesPackage ||
  //               companiesPackage === 'null' ||
  //               companiesPackage === '' ||
  //               companiesPackage === undefined
  //                 ? 0
  //                 : parseInt(companiesPackage) + parseInt(extraCompanies),
  //             status: 1,
  //             action: packageDetails !== undefined ? '1' : '0',
  //             session_token: props.currentUser.session_token,
  //             package_expires_in_days:
  //               packageId === '0' ? values.subscriptionDays : selectedPackage[0].package_expires_in_days,
  //             price: price,
  //           })
  //           .then((response) => {
  //             if (response.data.success === 1) {
  //               if (parseInt(price) === 0) {
  //                 sendUpgradtionMailForFreePackageCustomers();
  //                 trackStatusUpdateForAdmin();
  //               } else {
  //                 setOpen(true);
  //                 getGetCustomerDetails();
  //                 trackStatusUpdateForAdmin();
  //               }
  //             }
  //           });
  //       }
  //     }
  //   };

  const planDaysHandler = (planTerm) => {
    let days;
    switch (planTerm) {
      case 'yearly':
        days = 365;
        break;
      case 'monthly':
        days = 30;
        break;
      case 'halfYearly':
        days = 180;
        break;
      case 'quarterly':
        days = 90;
        break;
      default:
        days = 0;
    }

    return days;
  };

  const boxListStyles = {
    display: 'flex',
    gap: '20px',
    p: '10px',
  };

  const text1Styles = {
    m: 0,
    fontSize: styles.fontSize12,
    fontWeight: 500,
    color: palette.grey[800],
  };

  const iconStyles = {
    fontSize: styles.icon20,
    color: palette.grey[500],
  };
  const listItemGridStyles = {
    borderBottom: `1px solid ${palette.grey[200]}`,
  };
  const listItemGridContainerStyles = {
    alignItems: 'center',
  };

  const plans = ['Basic', 'Custom'];
  return (
    <Grid container spacing={0}>
      <Grid item xs={3} />
      <Grid item xs={6}>
        <Grid container spacing={2} component={Paper} elevation={10} sx={{ p: '10px' }}>
          <Grid item xs={12}>
            Plan Details
          </Grid>
          <Grid item xs={12}>
            <FormControl variant="standard" fullWidth>
              <FormLabel required>Plan</FormLabel>
              <Autocomplete
                size="small"
                disablePortal
                fullWidth
                options={plans}
                getOptionLabel={(option) => option}
                value={formData.plan !== '' ? formData.plan : null}
                onChange={(event, newValue) => handleChange('plan', newValue)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Plan"
                    error={Boolean(formErrors.plan)}
                    helperText={formErrors.plan}
                  />
                )}
                // error={formErrors.plan}
                // helperText={formErrors.plan}
                id="plan"
              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            {/* <RadioButtonsWithLabels formData={formData} handleChange={handleChange} /> */}
            <FormControl component="fieldset" size="small">
              <FormLabel component="legend" size="small">
                Plan Term
              </FormLabel>
              <RadioGroup
                size="small"
                row
                aria-label="plan-term"
                name="planTerm"
                value={formData.planTerm}
                onChange={(event) => handleChange('planTerm', event.target.value)}
              >
                {formData?.plan === 'Custom' ? (
                  <>
                    <FormControlLabel size="small" value="monthly" control={<Radio size="small" />} label="Monthly" />
                    <FormControlLabel
                      size="small"
                      value="quarterly"
                      control={<Radio size="small" />}
                      label="Quarterly"
                    />
                    <FormControlLabel
                      size="small"
                      value="halfYearly"
                      control={<Radio size="small" />}
                      label="Half Yearly"
                    />
                    <FormControlLabel size="small" value="yearly" control={<Radio size="small" />} label="Yearly" />
                  </>
                ) : (
                  <>
                    <FormControlLabel size="small" value="monthly" control={<Radio size="small" />} label="Monthly" />
                    <FormControlLabel size="small" value="yearly" control={<Radio size="small" />} label="Yearly" />
                  </>
                )}
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl variant="standard" fullWidth>
              <FormLabel required>Posts</FormLabel>
              <TextField placeholder="Posts" size="small" value="Unlimited" disabled />
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl variant="standard" fullWidth>
              <FormLabel required>Users</FormLabel>
              <TextField
                type="number"
                placeholder="Users"
                size="small"
                value={formData.users}
                onChange={(e) => handleNumberChange('users', e.target.value)}
                error={Boolean(formErrors.users)}
                helperText={formErrors.users}
                id="users"
                autoComplete="off"
                inputProps={{ min: 3 }}
                disabled={formData.plan === 'Basic'}
              />
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl variant="standard" fullWidth>
              <FormLabel required>Views</FormLabel>
              <TextField
                placeholder="Views"
                size="small"
                value={formData.views}
                disabled={formData.plan === 'Basic'}
              //   onChange={(e) => handleChange('views', e.target.value)}
              //   error={formErrors.views}
              //   helperText={formErrors.views}
              //   id="views"
              //   autoComplete="off"
              />
            </FormControl>
          </Grid>
          {formData.plan === 'Custom' && (
            <Grid item xs={6}>
              <FormControl variant="standard" fullWidth>
                <FormLabel>Extra Views</FormLabel>
                <TextField
                  placeholder="Views"
                  size="small"
                  value={formData.extraViews}
                  onChange={(e) => handleChange('extraViews', e.target.value)}
                  //   error={formErrors.views}
                  //   helperText={formErrors.views}
                  id="extraViews"
                  autoComplete="off"
                />
              </FormControl>
            </Grid>
          )}
          {/* <Grid item xs={12}></Grid>
          <Grid item xs={12}></Grid>
          <Grid item xs={12}></Grid> */}
          <Grid item xs={12}>
            <Box>
              <Typography
                paragraph
                sx={{ borderBottom: `1px solid ${palette.grey[700]}`, fontSize: styles.fontSize14, fontWeight: 600 }}
              >
                Billing
              </Typography>
              <Grid item xs={12} sx={listItemGridStyles}>
                <Grid container spacing={0} sx={listItemGridContainerStyles}>
                  <Grid item xs={4}>
                    <Box sx={boxListStyles}>
                      <Typography paragraph sx={{ ...text1Styles }}>
                        Plan Price
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={8}>
                    <Typography paragraph sx={{ ...text1Styles }}>
                      :&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;$
                      {formData.planTerm === 'yearly'
                        ? formData?.users * 1200
                        : formData.planTerm === 'monthly'
                          ? formData?.users * 100
                          : formData.planTerm === 'halfYearly'
                            ? formData?.users * 600
                            : formData.planTerm === 'quarterly'
                              ? formData?.users * 300
                              : null}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sx={listItemGridStyles}>
                <Grid container spacing={0} sx={listItemGridContainerStyles}>
                  <Grid item xs={4}>
                    <Box sx={boxListStyles}>
                      <Typography paragraph sx={{ ...text1Styles }}>
                        One Time Setup fee
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={8}>
                    <Typography paragraph sx={{ ...text1Styles }}>
                      :&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style={{ textDecoration: 'line-through' }}>$299</span>&nbsp;0
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              {formData?.plan === 'Custom' && (
                <Grid item xs={12} sx={listItemGridStyles}>
                  <Grid container spacing={0} sx={listItemGridContainerStyles}>
                    <Grid item xs={4}>
                      <Box sx={boxListStyles}>
                        <Typography paragraph sx={{ ...text1Styles }}>
                          Extra Views
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={8}>
                      <Typography paragraph sx={{ ...text1Styles }}>
                        :&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;$0
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              )}
              <Grid item xs={12} sx={listItemGridStyles}>
                <Grid container spacing={0} sx={listItemGridContainerStyles}>
                  <Grid item xs={4}>
                    <Box sx={boxListStyles}>
                      <Typography paragraph sx={{ ...text1Styles }}>
                        Discount
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={8}>
                    <TextField
                      type="number"
                      placeholder="Discount"
                      size="small"
                      value={formData.discount}
                      onChange={(e) => handleNumberChange('discount', e.target.value)}
                      error={Boolean(formErrors.discount)}
                      helperText={formErrors.discount}
                      id="discount"
                      autoComplete="off"
                      InputProps={{
                        endAdornment: <InputAdornment position="end">%</InputAdornment>,
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sx={listItemGridStyles}>
                <Grid container spacing={0} sx={listItemGridContainerStyles}>
                  <Grid item xs={4}>
                    <Box sx={boxListStyles}>
                      <Typography
                        paragraph
                        sx={{
                          m: 0,
                          fontSize: styles.fontSize14,
                          fontWeight: 800,
                          color: palette.grey[900],
                        }}
                      >
                        Total
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={8}>
                    <Typography
                      paragraph
                      sx={{
                        m: 0,
                        fontSize: styles.fontSize14,
                        fontWeight: 800,
                        color: palette.grey[900],
                      }}
                    >
                      :&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; $
                      {calculateTotalAmount(formData.users, formData.planTerm, formData.discount)}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%' }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                <Box sx={{}}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={formData.isTrail}
                        onChange={(e) => handleChange('isTrail', e.target.checked)}
                      />
                    }
                    label="Trail Period"
                  />
                  {/* {formData.isTrail && (
                    <FormControl style={{  minWidth: 120 }}>
                      
                      <Select
                        labelId="trial-duration-label"
                        value={formData.trialDuration}
                        onChange={handleDropdownChange}
                        displayEmpty
                        renderValue={
                          formData.trialDuration !== "" ? undefined : () => <em>Select Duration</em>
                        } 
                      >
                          <MenuItem value=""><em>Select Duration</em></MenuItem>
                        <MenuItem value={7}>1 week</MenuItem>
                        <MenuItem value={14}>2 weeks</MenuItem>
                      </Select>
                    </FormControl>
                  )} */}

                  {/* <Typography paragraph sx={{ m: 0, fontSize: styles.fontSize11, fontWeight: 600 }}>
                    {
                      customerDetails?.packageDetails?.trail_period === 0 ?
                        `Subscription Date : ${moment(customerDetails?.packageDetails?.package_start_date).format('LL')}`
                        : ''
                    }
                    {
                      customerDetails?.packageDetails?.trail_period === 1 ?
                        // `You are on trail period, your subscription starts from ${moment(customerDetails?.packageDetails?.package_start_date).format('LL')}`
                        `You are on trail period, your subscription starts from  ${adjustedStartDate}`
                        : ''
                    }
                  </Typography> */}
                </Box>
                <Box>
                  <Button variant="contained" onClick={submitHandler}>
                    Send Payment Details
                  </Button>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={3} />
      <Dialog fullScreen open={open} onClose={handleClose}>
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
              <Close />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Close
            </Typography>
            <Button autoFocus color="inherit" onClick={handleSendMail}>
              Send Mail
            </Button>
            {/* {buttonLoading ? (
              <Button autoFocus color="inherit" onClick={handleSendMail}>
                Send Mail
              </Button>
            ) : (
              <Button autoFocus color="inherit" onClick={handleSendMail} disabled>
                Sending...
              </Button>
            )} */}
          </Toolbar>
        </AppBar>
        <List>
          <Purchaseorderview
            price={customerDetails?.packageDetails?.price}
            customerDetails={customerDetails?.userDetails}
            customerid={customerDetails?.userDetails?.id}
            jobsAllowed={customerDetails?.packageDetails?.jobs_allowed}
            resumesAllowed={customerDetails?.packageDetails?.resumeviews_allowed}
            companiesAllowed={customerDetails?.packageDetails?.companies_allowed}
            recruitersAllowed={customerDetails?.packageDetails?.users_allowed}
            packageTitle={customerDetails?.packageDetails?.title ? customerDetails?.packageDetails?.title : ''}
          />
        </List>
      </Dialog>
    </Grid>
  );
};

export default PaymentForm;

const RadioButtonsWithLabels = ({ formData, handleChange }) => {
  return (
    <FormControl component="fieldset" size="small">
      <FormLabel component="legend" size="small">
        Plan Term
      </FormLabel>
      <RadioGroup
        size="small"
        row
        aria-label="plan-term"
        name="planTerm"
        value={formData.planTerm}
        onChange={(event) => handleChange('planTerm', event.target.value)}
      >
        {formData.plan === 'Custom' ? (
          <FormControlLabel size="small" value="yearly" control={<Radio size="small" />} label="Yearly" />
        ) : (
          <>
            <FormControlLabel size="small" value="monthly" control={<Radio size="small" />} label="Monthly" />
            <FormControlLabel size="small" value="yearly" control={<Radio size="small" />} label="Yearly" />
          </>
        )}
      </RadioGroup>
    </FormControl>
  );
};
